export var defaultProps = {
  buttonColor: "primary",
  size: "default"
};